// extracted by mini-css-extract-plugin
export default {"layout":"UserPagesLayout_layout__3zdAQ"};